import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const TL = (v) => new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',minimumFractionDigits:0}).format(v||0);

const DURUM = {
  yeni:           { label:'Yeni',          color:'#3B82F6', bg:'#DBEAFE', icon:'🆕' },
  gorusmede:      { label:'Görüşmede',     color:'#F59E0B', bg:'#FEF3C7', icon:'💬' },
  teklif_verildi: { label:'Teklif Verildi',color:'#8B5CF6', bg:'#EDE9FE', icon:'💰' },
  kayit_oldu:     { label:'Kayıt Oldu',    color:'#10B981', bg:'#D1FAE5', icon:'✅' },
  vazgecti:       { label:'Vazgeçti',      color:'#EF4444', bg:'#FEE2E2', icon:'❌' },
};

const KAYNAK = { web:'🌐 Web', sosyal_medya:'📱 Sosyal Medya', referans:'👥 Referans', eleman:'🚶 Eleman', reklam:'📢 Reklam', diger:'📌 Diğer' };

function AdayModal({ aday, onSave, onClose }) {
  const [form, setForm] = useState(aday || {
    ad:'', soyad:'', telefon:'', veli_adi:'', veli_telefon:'',
    email:'', hedef_sinif:'', ilgi_paketi:'', kaynak:'diger', notlar:'',
  });
  const [saving, setSaving] = useState(false);
  const handleSubmit = async () => {
    if (!form.ad || !form.soyad) { toast.error('Ad ve soyad zorunlu'); return; }
    setSaving(true);
    try { await onSave(form); } finally { setSaving(false); }
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{maxWidth:580}} onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{aday ? '✏️ Aday Düzenle' : '+ Yeni Aday'}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="muh-grid-2">
          <div className="form-group"><label className="form-label">Ad *</label>
            <input className="form-input" value={form.ad} onChange={e=>setForm(f=>({...f,ad:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Soyad *</label>
            <input className="form-input" value={form.soyad} onChange={e=>setForm(f=>({...f,soyad:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Telefon</label>
            <input className="form-input" value={form.telefon} onChange={e=>setForm(f=>({...f,telefon:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">E-posta</label>
            <input className="form-input" type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Veli Adı</label>
            <input className="form-input" value={form.veli_adi} onChange={e=>setForm(f=>({...f,veli_adi:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Veli Telefon</label>
            <input className="form-input" value={form.veli_telefon} onChange={e=>setForm(f=>({...f,veli_telefon:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Hedef Sınıf</label>
            <input className="form-input" value={form.hedef_sinif} onChange={e=>setForm(f=>({...f,hedef_sinif:e.target.value}))} placeholder="12-TYT, 8. Sınıf..." /></div>
          <div className="form-group"><label className="form-label">İlgilendiği Paket</label>
            <input className="form-input" value={form.ilgi_paketi} onChange={e=>setForm(f=>({...f,ilgi_paketi:e.target.value}))} placeholder="TYT Hazırlık..." /></div>
          <div className="form-group"><label className="form-label">Kaynak</label>
            <select className="form-input" value={form.kaynak} onChange={e=>setForm(f=>({...f,kaynak:e.target.value}))}>
              {Object.entries(KAYNAK).map(([v,l])=><option key={v} value={v}>{l}</option>)}
            </select>
          </div>
          {aday && (
            <div className="form-group"><label className="form-label">Durum</label>
              <select className="form-input" value={form.durum} onChange={e=>setForm(f=>({...f,durum:e.target.value}))}>
                {Object.entries(DURUM).map(([v,d])=><option key={v} value={v}>{d.icon} {d.label}</option>)}
              </select>
            </div>
          )}
          <div className="form-group" style={{gridColumn:'1/-1'}}><label className="form-label">Notlar</label>
            <textarea className="form-input" rows={2} value={form.notlar} onChange={e=>setForm(f=>({...f,notlar:e.target.value}))} /></div>
        </div>
        <div style={{display:'flex',justifyContent:'flex-end',gap:10,marginTop:16}}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving?<div className="spinner" style={{width:16,height:16}}/>:'💾 Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}

function GorusmeModal({ adayId, onSave, onClose }) {
  const [form, setForm] = useState({ kanal:'telefon', ozet:'', teklif_tutari:'', sonraki_adim:'', hatirlatma_tarihi:'' });
  const [saving, setSaving] = useState(false);
  const handleSubmit = async () => {
    if (!form.ozet) { toast.error('Görüşme özeti zorunlu'); return; }
    setSaving(true);
    try { await onSave(form); } finally { setSaving(false); }
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{maxWidth:480}} onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">💬 Görüşme Ekle</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          <div className="form-group"><label className="form-label">İletişim Kanalı</label>
            <select className="form-input" value={form.kanal} onChange={e=>setForm(f=>({...f,kanal:e.target.value}))}>
              <option value="yuz_yuze">🤝 Yüz Yüze</option><option value="telefon">📞 Telefon</option>
              <option value="whatsapp">💬 WhatsApp</option><option value="email">📧 E-posta</option>
            </select>
          </div>
          <div className="form-group"><label className="form-label">Görüşme Özeti *</label>
            <textarea className="form-input" rows={3} value={form.ozet} onChange={e=>setForm(f=>({...f,ozet:e.target.value}))} placeholder="Görüşmede ne konuşuldu..." /></div>
          <div className="form-group"><label className="form-label">Teklif Tutarı (₺)</label>
            <input className="form-input" type="number" value={form.teklif_tutari} onChange={e=>setForm(f=>({...f,teklif_tutari:e.target.value}))} placeholder="0" /></div>
          <div className="form-group"><label className="form-label">Sonraki Adım</label>
            <input className="form-input" value={form.sonraki_adim} onChange={e=>setForm(f=>({...f,sonraki_adim:e.target.value}))} placeholder="Tekrar aranacak, deneme sınavına davet..." /></div>
          <div className="form-group"><label className="form-label">Hatırlatma Tarihi</label>
            <input className="form-input" type="date" value={form.hatirlatma_tarihi} onChange={e=>setForm(f=>({...f,hatirlatma_tarihi:e.target.value}))} /></div>
        </div>
        <div style={{display:'flex',justifyContent:'flex-end',gap:10,marginTop:16}}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving?<div className="spinner" style={{width:16,height:16}}/>:'💾 Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function CrmPage() {
  const navigate = useNavigate();
  const [adaylar, setAdaylar]         = useState([]);
  const [huni, setHuni]               = useState([]);
  const [total, setTotal]             = useState(0);
  const [loading, setLoading]         = useState(true);
  const [modal, setModal]             = useState(null);
  const [gorusmeModal, setGorusmeModal] = useState(null);
  const [secili, setSecili]           = useState(null);
  const [gorusmeler, setGorusmeler]   = useState([]);
  const [filtre, setFiltre]           = useState({ durum:'', arama:'' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams(Object.fromEntries(Object.entries(filtre).filter(([,v])=>v)));
      const r = await axios.get(`/muhasebe/crm?${params}`);
      if (r.data.success) { setAdaylar(r.data.data); setTotal(r.data.total); setHuni(r.data.huni||[]); }
    } catch {} finally { setLoading(false); }
  }, [filtre]);

  useEffect(() => { load(); }, [load]);

  const loadGorusmeler = async (adayId) => {
    try {
      const r = await axios.get(`/muhasebe/crm/${adayId}/gorusmeler`);
      if (r.data.success) setGorusmeler(r.data.data);
    } catch {}
  };

  const handleAdaySave = async (form) => {
    try {
      if (form.id) await axios.put(`/muhasebe/crm/${form.id}`, form);
      else         await axios.post('/muhasebe/crm', form);
      toast.success(form.id ? 'Güncellendi' : 'Aday eklendi');
      setModal(null); load();
    } catch (e) { toast.error(e.response?.data?.message || 'Hata'); }
  };

  const handleGorusmeSave = async (form) => {
    try {
      await axios.post(`/muhasebe/crm/${secili.id}/gorusme`, form);
      toast.success('Görüşme kaydedildi');
      setGorusmeModal(null);
      loadGorusmeler(secili.id); load();
    } catch (e) { toast.error('Hata'); }
  };

  const handleSozlesmeye = async (adayId) => {
    try {
      const r = await axios.post(`/muhasebe/crm/${adayId}/sozlesmeye-don`);
      if (r.data.success) {
        toast.success('Aday kayıt olarak işaretlendi! Sözleşme sayfasına yönlendiriliyorsunuz...');
        setTimeout(() => navigate('/muhasebe/sozlesmeler'), 1500);
      }
    } catch (e) { toast.error('Hata'); }
  };

  const seciliAday = (aday) => {
    setSecili(aday);
    loadGorusmeler(aday.id);
  };

  const huniMap = huni.reduce((a,h) => ({...a,[h.durum]:h.sayi}), {});

  return (
    <div style={{display:'flex',flexDirection:'column',gap:20}}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{fontFamily:'var(--font-ui)',fontWeight:900}}>🎯 CRM — Aday Takibi</h2>
          <div className="section-subtitle">{total} aday kayıtlı</div>
        </div>
        <button className="btn btn-primary" onClick={()=>setModal('yeni')}>+ Aday Ekle</button>
      </div>

      {/* Huni */}
      <div className="animate-fadeInUp stagger-1 muh-grid-5">
        {Object.entries(DURUM).map(([k,d])=>(
          <div key={k} className="card" style={{background:d.bg,border:`1.5px solid ${d.color}30`,padding:14,textAlign:'center',cursor:'pointer'}}
            onClick={()=>setFiltre(f=>({...f,durum:f.durum===k?'':k}))}>
            <div style={{fontSize:'1.5rem',marginBottom:6}}>{d.icon}</div>
            <div style={{fontFamily:'var(--font-ui)',fontWeight:900,fontSize:'1.4rem',color:d.color}}>{huniMap[k]||0}</div>
            <div style={{fontSize:'0.72rem',color:d.color,fontWeight:600}}>{d.label}</div>
          </div>
        ))}
      </div>

      {/* Filtre */}
      <div className="card muh-filter-row" style={{padding:'10px 14px'}}>
        <input className="form-input" placeholder="🔍 Ad, soyad veya telefon..." value={filtre.arama}
          onChange={e=>setFiltre(f=>({...f,arama:e.target.value}))} style={{width:280,height:36}} />
        {Object.entries(DURUM).map(([k,d])=>(
          <button key={k} className={`chip ${filtre.durum===k?'active':''}`}
            style={filtre.durum===k?{background:d.bg,color:d.color,borderColor:d.color}:{}}
            onClick={()=>setFiltre(f=>({...f,durum:f.durum===k?'':k}))}>
            {d.icon} {d.label}
          </button>
        ))}
        {(filtre.durum||filtre.arama) && <button className="btn btn-ghost btn-sm" onClick={()=>setFiltre({durum:'',arama:''})}>✕</button>}
      </div>

      <div className={secili ? 'muh-two-col' : ''} style={{display:'grid',gridTemplateColumns:secili?'1fr 400px':'1fr',gap:16}}>
        {/* Liste */}
        <div className="card animate-fadeInUp" style={{padding:0}}>
          {loading ? <div className="page-loader" style={{minHeight:200}}><div className="spinner"/></div>
          : adaylar.length===0 ? <div className="empty-state" style={{padding:56}}><div style={{fontSize:'3rem'}}>🎯</div><h3>Aday bulunamadı</h3></div>
          : (
            <div className="table-container">
              <table className="table">
                <thead><tr><th>Aday</th><th>İletişim</th><th>Paket</th><th>Kaynak</th><th>Görüşme</th><th>Durum</th><th></th></tr></thead>
                <tbody>
                  {adaylar.map((a,i)=>{
                    const d = DURUM[a.durum]||DURUM.yeni;
                    return (
                      <tr key={i} style={{cursor:'pointer',background:secili?.id===a.id?'var(--blue-dim)':''}}
                        onClick={()=>secili?.id===a.id?setSecili(null):seciliAday(a)}>
                        <td>
                          <div style={{fontWeight:700}}>{a.ad} {a.soyad}</div>
                          {a.veli_adi && <div style={{fontSize:'0.72rem',color:'var(--text-muted)'}}>Veli: {a.veli_adi}</div>}
                        </td>
                        <td style={{fontSize:'0.82rem'}}>
                          <div>{a.telefon}</div>
                          {a.veli_telefon && <div style={{color:'var(--text-muted)'}}>{a.veli_telefon}</div>}
                        </td>
                        <td style={{fontSize:'0.78rem'}}>{a.ilgi_paketi||a.hedef_sinif||'—'}</td>
                        <td style={{fontSize:'0.78rem',color:'var(--text-muted)'}}>{KAYNAK[a.kaynak]||a.kaynak}</td>
                        <td style={{textAlign:'center'}}>
                          <span className="badge badge-muted">{a.gorusme_sayisi||0}</span>
                        </td>
                        <td><span className="badge" style={{background:d.bg,color:d.color}}>{d.icon} {d.label}</span></td>
                        <td>
                          <div style={{display:'flex',gap:5}}>
                            <button className="btn btn-ghost btn-sm" onClick={e=>{e.stopPropagation();setModal(a);}}>✏️</button>
                            {a.durum!=='kayit_oldu'&&a.durum!=='vazgecti' && (
                              <button className="btn btn-sm" style={{background:'#10B981',color:'white',border:'none',fontSize:'0.75rem'}}
                                onClick={e=>{e.stopPropagation();handleSozlesmeye(a.id);}}>✅ Kayıt</button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Detay paneli */}
        {secili && (
          <div className="card animate-fadeInUp" style={{padding:0}}>
            <div style={{padding:'14px 16px',borderBottom:'1px solid var(--border)',display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
              <div>
                <div style={{fontFamily:'var(--font-ui)',fontWeight:800}}>{secili.ad} {secili.soyad}</div>
                <div style={{fontSize:'0.78rem',color:'var(--text-muted)'}}>
                  📞 {secili.telefon} {secili.veli_telefon?`· Veli: ${secili.veli_telefon}`:''}
                </div>
                {secili.ilgi_paketi && <div style={{fontSize:'0.78rem',marginTop:2}}>{secili.ilgi_paketi} · {secili.hedef_sinif}</div>}
              </div>
              <button className="btn btn-ghost btn-sm" onClick={()=>setSecili(null)}>✕</button>
            </div>
            <div style={{padding:'10px 16px',borderBottom:'1px solid var(--border)',display:'flex',gap:8}}>
              <button className="btn btn-primary btn-sm" onClick={()=>setGorusmeModal(secili.id)}>+ Görüşme</button>
              <button className="btn btn-sm" style={{background:'#10B981',color:'white',border:'none'}}
                onClick={()=>handleSozlesmeye(secili.id)}>✅ Kayıt Yaptır</button>
            </div>
            <div style={{maxHeight:400,overflowY:'auto'}}>
              {gorusmeler.length===0 ? (
                <div className="empty-state" style={{padding:32}}><p>Görüşme kaydı yok</p></div>
              ) : gorusmeler.map((g,i)=>(
                <div key={i} style={{padding:'12px 16px',borderBottom:'1px solid var(--border)'}}>
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                    <span style={{fontSize:'0.78rem',fontWeight:700,color:'var(--blue)'}}>
                      {{yuz_yuze:'🤝',telefon:'📞',whatsapp:'💬',email:'📧'}[g.kanal]||'💬'} {g.kanal}
                    </span>
                    <span style={{fontSize:'0.72rem',color:'var(--text-muted)'}}>{new Date(g.created_at).toLocaleDateString('tr-TR')}</span>
                  </div>
                  <div style={{fontSize:'0.85rem',marginBottom:4}}>{g.ozet}</div>
                  {g.teklif_tutari>0 && <div style={{fontSize:'0.82rem',color:'#10B981',fontWeight:700}}>💰 Teklif: {TL(g.teklif_tutari)}</div>}
                  {g.sonraki_adim && <div style={{fontSize:'0.78rem',color:'var(--text-muted)',marginTop:4}}>→ {g.sonraki_adim}</div>}
                  {g.hatirlatma_tarihi && <div style={{fontSize:'0.72rem',color:'#F59E0B',marginTop:2}}>⏰ {new Date(g.hatirlatma_tarihi).toLocaleDateString('tr-TR')}</div>}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {modal && <AdayModal aday={modal==='yeni'?null:modal} onSave={handleAdaySave} onClose={()=>setModal(null)} />}
      {gorusmeModal && <GorusmeModal adayId={gorusmeModal} onSave={handleGorusmeSave} onClose={()=>setGorusmeModal(null)} />}
    </div>
  );
}
